<template>
    <div class="wrapper">
    <div class="row row-wider">
    <div class="col-md-12" style="min-height: 150px;">
    <tabs nav-style="tabs" v-model="activeTabIndex">
        <tab header="Production Record">
            <loader v-if="culturalResourceRecordingLoading"/>
            <div class="container">
                <div class="sticky" v-if="!isSegment">
                    <ul>
                        <li v-if="isAdmin"><button class="btn btn-primary" v-on:click="toggleFormEnabled">{{formEnabledToggle ? "Disable Edit" : "Enable Edit" }}</button></li>
                        <li><a href="#overview">Overview</a></li>
                        <li><a href="#location">Location</a></li>
                        <li><a href="#nationalRegisterStatus">Register Status</a></li>
                        <li><a href="#investigativeHistory">Investigative History</a></li>
                        <li><a href="#propertyDescription">Property Description</a></li>
                        <li><a href="#siteSetting">Site Setting</a></li>
                        <li v-if="culturalResource.siteTypeId !== propertyTypeEnum.Building"><a href="#siteNarrative">Site Narrative</a></li>
                        <li v-if="culturalResource.siteTypeId == propertyTypeEnum.Building"><a href="#buildingDescHistory">Building Desc./History</a></li>
                    </ul>
                </div>
                <div v-if="isSegment && isAdmin">
                    <button class="btn btn-primary" v-on:click="toggleFormEnabled">{{formEnabledToggle ? "Disable Edit" : "Enable Edit" }}</button>
                </div>
                <div class="panel panel-offset" id="overview">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Overview</h3>
                    </div>
                    <div v-show="!adminFormEnabled" class="panel-body">
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Smithsonian Number</label>
                            <div class="col-md-4 text-label">
                                {{culturalResource.smithsonianNumber}}
                                <!-- <div class="pull-right" v-if="isMigrated">
                                    <h4><span class="label label-default" style="color: #FFFFFF">Migrated</span></h4>
                                </div> -->
                            </div>
                            <label class="col-md-2 control-label text-label">Record Type</label>
                            <div class="col-md-4 text-label" v-if="culturalResource.isNoFormOnFile" style="color: red;">
                                <b>No Form on File</b>
                            </div>
                            <div class="col-md-4 text-label" v-else>
                                {{culturalResourceRecording.recordingTypeDescription}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Site Name</label>
                            <div class="col-md-4 text-label">
                                {{culturalResourceRecording.siteName}}
                            </div>
                            <label class="col-md-2 control-label text-label">Member of District or Linear</label>
                            <div class="col-md-4">
                                <div class="text-label">{{culturalResource.grouping}}
                                <a class="fa fa-edit" style="margin-left: 10px; font-size: 18px;"
                                    v-on:click="goCulturalResourceGroup()"></a></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">
                                Property Category
                                <button style="margin: 5px" class="btn btn-default" v-on:click="$refs['secondaryCategoryModal'].open()">Secondary Categories</button>
                            </label>
                            <div class="col-md-4 text-label">
                                {{culturalResourceRecording.siteTypeDescription}}
                                <div class="pull-right" v-if="culturalResource.isMonument">
                                    <h4><span class="label label-default" style="color: #FFFFFF">Monument</span></h4>
                                </div>
                                <div class="pull-right" v-if="culturalResource.isLandmark">
                                    <h4><span class="label label-default" style="color: #FFFFFF">Landmark</span></h4>
                                </div>
                                <div class="pull-right" v-if="culturalResource.isListed">
                                    <h4><span class="label label-default" style="color: #FFFFFF">Listed</span></h4>
                                </div>
                            </div>
                            <modal ref="secondaryCategoryModal">
                                <h3 slot="header">Secondary Property Categories</h3>
                                <div slot="body">
                                    <div class="form-group">
                                        <div class="col-md-12">
                                            <checkboxPanel :readonly="true" :numColumns="4" :lookupList="siteTypeList" ref="siteTypePanel" :fieldName="'siteTypeId'" name="stCB" />
                                        </div>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="row">
                                        <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['secondaryCategoryModal'].close()">Close</button>
                                    </div>
                                </div>
                            </modal>
                            <label class="col-md-2 control-label text-label">
                                Time Period
                                <button style="margin: 5px" class="btn btn-default" v-on:click="$refs['secondaryTimePeriodModal'].open()">Secondary Time Periods</button>
                            </label>
                            <div class="col-md-4 text-label">
                                {{culturalResourceRecording.timePeriodDescription}}
                            </div>
                            <modal ref="secondaryTimePeriodModal">
                                <h3 slot="header">Secondary Time Periods</h3>
                                <div slot="body">
                                    <div class="form-group">
                                        <div class="col-md-12">
                                            <checkboxPanel :readonly="true" :numColumns="4" :lookupList="timePeriodList" ref="timePeriodPanel" :fieldName="'id'" name="tpCB" />
                                        </div>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="row">
                                        <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['secondaryTimePeriodModal'].close()">Close</button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Is Confidential</label>
                            <div class="col-md-4">
                                <div class="text-label">{{culturalResource.isConfidential ? "Yes" : "No" }}</div>
                            </div>
                            <label class="col-md-2 control-label text-label">Is Inactive</label>
                            <div class="col-md-4">
                                <div class="text-label">{{culturalResource.isInactive ? "Yes" : "No" }}</div>
                            </div>
                            <div v-if="culturalResourceRecording.siteTypeId === propertyTypeEnum.District">
                                <label  class="col-md-2 control-label text-label">District Ownership Type</label>
                                <div class="col-md-4 text-label">
                                    {{ (districtOwnershipTypeList.find(x => x.id === culturalResourceRecording.districtOwnershipTypeId) || { description: 'None'}).description }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <landOwnership :parentId="culturalResource.culturalResourceId" source='CulturalResource' formDisabled=true />
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Identifiers</label>
                            <div class="col-md-10 text-label">
                                <table class="table" style="width=100%">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Owner</th>
                                            <th>Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="identifier in culturalResourceIdentifiers" :key="identifier.index">
                                            <td>{{identifier.identifierTypeDescription}}</td>
                                            <td>{{identifier.parentDescription}}</td>
                                            <td>{{identifier.identifier}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <identificationForm ref="identificationForm" v-if="culturalResourceRecording" :culturalResourceRecording="culturalResourceRecording"
                            :culturalResource="culturalResource" :productionAdminEdit="true" source='CulturalResource' v-on:overviewSaved="loadData" />
                    </div>
                </div>
                <div v-if="culturalResource.isConfidential && adminFormEnabled" class="panel panel-offset" id="confidential">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Confidential Settings</h3>
                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <div class="form-group" >
                                <label class="col-md-3 control-label">Tribal Consultation:</label>
                                <div class="col-md-7">
                                    <select class="form-control" v-model="culturalResource.tribalConsultationId">
                                        <option :value="null">None</option>
                                        <option :value="1">Tribal Sensitive</option>
                                        <option :value="2">Traditional Cultural Property</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" >
                                <label class="col-md-3 control-label">Confidential User Roles</label>
                                <div class="col-md-7">
                                    <div v-for="role in roleList" v-bind:key="role.roleId" class="checkbox checkbox-inline">
                                        <input type="checkbox" v-model="confidentialRoleList" :id="role.roleId" :value="role.roleId" />
                                            <label v-bind:for="role.roleId">{{ role.description}}</label>
                                    </div>
                                </div>
                            </div>
                            <label class="col-md-3 control-label">Confidential Organizations</label>
                            <div class="col-md-7">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Organization Name</th>
                                            <th>Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in confidentialOrgList" v-bind:key="item.culturalResourceConfidentialOrgId">
                                            <td>{{item.description}}</td>
                                            <td><a class="fa fa-ban" style="font-size: 18px;" v-on:click="removeOrganization(index)"></a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-1 col-md-offset-3">
                                <button class="form-contol btn" v-on:click="$refs['organizationModal'].open()">Add Organization</button>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2">
                                <button class="btn btn-primary pull-right" v-on:click="saveConfidentialSetting">Save</button>
                            </div>
                        </div>
                        <modal ref="organizationModal">
                            <div slot="header" class="row">
                                <h3 class="pull-left">Add User Organization</h3>
                                <button class="btn pull-right" v-on:click="$refs['organizationModal'].close()">X</button>
                            </div>
                            <div slot="body">
                                <div class="form form-horizontal">
                                    <div class="form-group">
                                        <label class="col-md-3 control-label">Organization</label>
                                        <div class="col-md-6">
                                            <select class="form-control" v-model="confidentialOrgDto.organizationId">
                                                <option disabled :value="null">Select An Organization</option>
                                                <option v-for="org in organizationList" v-bind:key="org.organizationId" :value="org.organizationId">{{org.description}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="footer">
                                <div class="row">
                                    <button :disabled="confidentialOrgDto.organizationId == null" name="buttonDone" class="btn btn-primary col-md-3" v-on:click="addOrganization()">Add</button>
                                </div>
                            </div>
                        </modal>
                    </div>
                </div>
                <div class="panel panel-offset" id="location" v-if="!isSegment">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Location</h3>
                    </div>
                    <div v-if="!adminFormEnabled" class="panel-body">
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Site TRS</label>
                            <div class="col-md-10 text-label">
                                {{siteTrsList.join(', ')}}
                            </div>
                        </div>
                        <div class="form-group" v-if="historicalTrs.length > 0  && isAdmin">
                            <label class="col-md-2 control-label text-label">Historical TRS</label>
                            <div class="col-md-10 text-label">
                                <tr v-for="trs in historicalTrs" v-bind:key="trs.historicalTrsDate" style="background-color:#edf0f2">
                                    <td>{{trs.historicalTrsDate}}:&nbsp;&nbsp;{{trs.plssLocationDisplay}}</td>
                                </tr>
                            </div>
                        </div>
                        <div class="form-group" v-if="location.isInsufficientLocationInfo">
                            <label class="col-md-12 control-label text-label" style="color:red;">Insufficient Location Information</label>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Street Address</label>
                            <div class="col-md-5 text-label">
                                {{location.streetAddress}}
                            </div>
                            <label class="col-md-1 control-label text-label">Town</label>
                            <div class="col-md-4 text-label">
                                {{location.town}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Lot-Block</label>
                            <div class="col-md-5 text-label">
                                {{location.lotBlock}}
                            </div>
                            <label class="col-md-1 control-label text-label">Parcel</label>
                            <div class="col-md-4 text-label">
                                {{location.parcel}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Access Notes</label>
                            <div class="col-md-5 text-label">
                                {{location.accessNotes}}
                            </div>
                        </div>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <locationForm :crrId="crrId" :siteTrsList="siteTrsList" :productionAdminEdit="true" :historicalTrs="historicalTrs" />
                    </div>
                </div>

                <div class="panel panel-offset" id="nationalRegisterStatus" v-if="!isSegment">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">National Register Status</h3>
                    </div>
                    <div v-if="!adminFormEnabled" class="panel-body">
                        <nationalRegisterStatus :crrId="crrId" ref="nationalRegisterStatus"></nationalRegisterStatus>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <nationalRegisterStatusForm :crrId="crrId" />
                    </div>
                </div>

                <div class="panel panel-offset" name="inventoryHistoryPanel" id="investigativeHistory" v-if="!isSegment">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Investigative History</h3>
                    </div>
                    <div v-if="!adminFormEnabled" class="panel-body">
                        <investigativeHistory :crrId="crrId" ref="investigativeHistory"></investigativeHistory>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <investigativeHistoryForm :crrId="crrId" />
                    </div>
                </div>

                <div class="panel panel-offset" id="propertyDescription" v-if="!isSegment">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Property Description</h3>
                    </div>
                    <div v-if="!adminFormEnabled" class="panel-body">
                        <propertyDescription :crrId="crrId" ref="propertyDescription"></propertyDescription>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <propertyDescriptionForm :crrId="crrId" />
                    </div>
                </div>

                <div class="panel panel-offset" name="siteSettingPanel" id="siteSetting" v-if="!isSegment">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Site Setting</h3>
                    </div>
                    <div v-if="!adminFormEnabled" class="panel-body">
                        <siteSetting :crrId="crrId" ref="siteSetting"></siteSetting>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <siteSettingForm :crrId="crrId" />
                    </div>
                </div>

                <div v-if="culturalResourceRecording.siteTypeId !== propertyTypeEnum.Building" class="panel panel-offset" name="siteNarrative" id='siteNarrative'>
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Site Narrative</h3>
                    </div>
                    <div v-if="!adminFormEnabled" class="panel-body">
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Description</label>
                            <div class="col-md-10">
                                <div v-html="culturalResourceRecording.siteNarrative" class="form-control" style="height: auto;"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <form @submit.prevent="saveSiteNarrative" class="form">
                            <div class="form-group">
                                <label class="col-md-2 control-label">Description</label>
                                <div class="col-md-10">
                                    <!-- <textarea class="form-control" rows="10" v-model="culturalResourceRecording.siteNarrative"/> -->
                                    <editor id="editorSiteNarrative" v-model="culturalResourceRecording.siteNarrative" :init="editor.options"></editor>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-2">
                                    <button class="btn btn-primary pull-right" v-on:click="saveSiteNarrative">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div v-if="culturalResourceRecording.siteTypeId == propertyTypeEnum.Building" class="panel panel-offset" name="buildingDescHistory" id='buildingDescHistory'>
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">Property Desc./History</h3>
                    </div>
                    <div v-if="!adminFormEnabled" class="panel-body">
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Property Description</label>
                            <div class="col-md-10">
                                <div v-html="culturalResourceRecording.buildingDescription" class="form-control" style="height: auto;"></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label text-label">Property History</label>
                            <div class="col-md-10">
                                <div v-html="culturalResourceRecording.buildingHistory" class="form-control" style="height: auto;"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="adminFormEnabled" class="panel-body">
                        <form v-if="!culturalResourceRecordingLoading" @submit.prevent="submit" class="form">
                            <div class="form-group">
                                <label class="col-md-2 control-label">Property Description</label>
                                <div class="col-md-10">
                                    <editor id="editorBuildingDesc" v-model="culturalResourceRecording.buildingDescription" :init="editor.options"></editor>
                                    <!-- <textarea class="form-control" rows="10" v-model="culturalResourceRecording.buildingDescription"/> -->
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Property History</label>
                                <div class="col-md-10">
                                    <editor id="editorBuildingHist" v-model="culturalResourceRecording.buildingHistory" :init="editor.options"></editor>
                                    <!-- <textarea class="form-control" rows="10" v-model="culturalResourceRecording.buildingHistory"/> -->
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-2">
                                    <button class="btn btn-primary pull-right" v-on:click="saveSiteNarrative">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </tab>
        <tab header="Eligibility">
            <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :isProduction="true"></siteHeader>
            <div v-if="isAdmin">
                <button class="btn btn-primary" v-on:click="toggleFormEnabled">{{formEnabledToggle ? "Disable Edit" : "Enable Edit" }}</button>
            </div>
            <div class="panel panel-offset spacer" id="eligibility" v-if="!isSegment">
                <div class="panel-heading green-bg">
                    <h3 class="panel-title">Current Eligibility</h3>
                </div>
                <div v-if="!adminFormEnabled" class="panel-body">
                    <div class="form-group">
                        <div v-if="currentEval.eligibilityId === eligibilityEnum.Eligible && currentEval.isKeeperDetermined &&
                            currentEvalShpoConcurred">
                            <label class="col-md-4 control-label" style="color: red;">Eligible by NRHP Keeper</label>
                            <!-- <span class="form-control inline red">{{ currentEval.isKeeperDetermined ? 'Yes' : 'No' }}</span> -->
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">NRHP Status</label>
                        <div class="col-md-8">
                            <span class="form-control">{{ listedLandmarkMonument ? listedLandmarkMonument : (currentEvalShpoConcurred ? currentEval.eligibilityDescription : 'Unevaluated') }}</span>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                        <div class="col-md-3">
                            <div style="padding-top:0px">
                                <label class="inline">Listed</label>
                                <span class="form-control inline">{{ culturalResource.isListed ? 'Yes' : 'No' }}</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div style="padding-top:0px">
                                <label class="inline">Landmark</label>
                                <span class="form-control inline">{{ culturalResource.isLandmark ? 'Yes' : 'No' }}</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div style="padding-top:0px">
                                <label class="inline">Monument</label>
                                <span class="form-control inline">{{ culturalResource.isMonument ? 'Yes' : 'No' }}</span>
                            </div>
                        </div>
                    </div> -->
                    <template v-if="currentEvalShpoConcurred">
                        <div class="form-group">
                            <label class="col-md-2 control-label">Source</label>
                            <div class="col-md-3">
                                <span class="form-control">{{currentEval.concurredDescription}}</span>
                            </div>
                        </div>
                        <div v-if="currentEval.eligibilityId === eligibilityEnum.Eligible">
                            <div class="form-group">
                                <label class="col-md-2 control-label">Criteria Met</label>
                                <div disabled class="col-md-8">
                                    <div v-if="currentEval.isEligibleA" class="checkbox-inline">
                                        <label class="form-control">A</label>
                                    </div>
                                    <div v-if="currentEval.isEligibleB" class="checkbox-inline">
                                        <label class="form-control">B</label>
                                    </div>
                                    <div v-if="currentEval.isEligibleC" class="checkbox-inline">
                                        <label class="form-control">C</label>
                                    </div>
                                    <div v-if="currentEval.isEligibleD" class="checkbox-inline">
                                        <label class="form-control">D</label>
                                    </div>
                                </div>

                            </div>
                            <div v-if="currentEval.isEligibleB" class="form-group">
                                <label class="col-md-2 control-label">Associated Person</label>
                                <div  class="col-md-3">
                                    <span class="form-control">{{currentEval.associatedPerson}}</span>
                                </div>
                            </div>
                            <div v-if="false">
                                <div class="form-group">
                                    <label class="col-md-2 control-label">Contributing Component: </label>
                                    <div class="col-md-2">
                                        <span class="form-control">{{ currentEval.isContributing ? 'Contributing' : 'Not Contributing' }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="form-group">
                                <label class="col-md-2 control-label">Effect</label>
                                <div class="col-md-2">
                                    <span class="form-control">{{currentEval.effectDescription}}</span>
                                </div>
                            </div> -->
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">Discuss Condition and Integrity</label>
                            <div class="col-md-10">
                                <!-- <div class="form-control" style="width:750px; min-height: 100px; white-space: pre-line;">{{currentEval.justification}}</div> -->
                                <textarea readonly style="width:750px; color: #555555;" name="justification" class="form-control" v-model="currentEval.justification" rows="6" />
                            </div>
                        </div>
                    </template>

                </div>
                <div v-if="adminFormEnabled" class="panel-body">
                    <siteEligibilityForm :evaluation="currentEval" :culturalResource="culturalResource" v-on:eligibilitySaved="loadData"/>
                </div>
            </div>
            <div v-show="isSegment">
                <segmentEvaluationForm ref="segmentEval" :crr="culturalResourceRecording.culturalResourceRecordingId" :segmentHead="segmentHead" :segHeadEval="segHeadEval" :culturalResourceId="culturalResourceId" :adminFormEnabled="adminFormEnabled">
                </segmentEvaluationForm>
            </div>
            <div class="panel panel-offset spacer" id="eligibilityHistory">
                <div class="panel-heading green-bg">
                    <h3 class="panel-title">Eligibility History</h3>
                </div>
                <div v-if="!adminFormEnabled" class="panel-body">
                    <div class="form-group">
                        <v-client-table :data="eligibilityHistory" :columns="elHistGridSpecColumns" :options="elHistGridSpec.options">
                            <template slot="view" slot-scope="props">
                                <div style="text-align: center">
                                    <!-- <a  class="fa fa-edit" style="font-size: 18px;" v-on:click="viewRecording(props.row.culturalResourceRecordingId)"></a> -->
                                    <router-link v-if="!props.row.isProduction" :to="{ path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                                    <span v-else>Migrated</span>
                                </div>
                            </template>
                        </v-client-table>
                    </div>
                </div>
            </div>
        </tab>
        <tab header="Attachments">
            <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :isProduction="true"
                :currentEval="currentEval"></siteHeader>
            <div v-if="isAdmin">
                <button class="btn btn-primary" v-on:click="toggleFormEnabled">{{formEnabledToggle ? "Disable Edit" : "Enable Edit" }}</button>
            </div>
            <attachments ref="attachments" :formDisabled="!adminFormEnabled" :adminProdEdit="adminFormEnabled" :crrId="crrId" :loadOnMount="false"></attachments>
        </tab>
        <tab header="Documents">
            <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :isProduction="true"
                :currentEval="currentEval"></siteHeader>
            <siteDocuments ref="siteDocuments" :loadOnMount="false" :prodCrrId="crrId" :isShpo="isShpo"></siteDocuments>
            <labResults ref="labResults" :loadOnMount="false"  :culturalResourceId="culturalResourceId"></labResults>
        </tab>
        <tab header="Map" :disabled="culturalResourceRecordingLoading">
            <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :isProduction="true"
                :currentEval="currentEval"></siteHeader>
            <mapx ref="mapx" :mediaTypeId="mediaTypeId" :parentId="crrId" :loadOnMount="false" :smithsonianNo="culturalResourceRecording.smithsonianNumber"></mapx>
        </tab>
        <tab header="Recording History">
            <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :isProduction="true"
                :currentEval="currentEval"></siteHeader>
            <culturalResourceRecordingHistory ref="crrHistory" :loadOnMount="false" :productionCrrId="crrId" :siteTrsList="siteTrsList" :smithNo="culturalResource.smithsonianNumber"></culturalResourceRecordingHistory>
            <div>
                <h5>Site Number Request</h5>
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:10%">View</th>
                            <th style="width:40%">Project Name</th>
                            <th style="width:50%">Current Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="snr in siteNumberRequest" v-bind:key="snr.siteNumberRequestId" style="background-color:#edf0f2">
                            <td>
                                <div style="text-align: center;">
                                    <router-link :to="{ path: '/SiteNumberRequest/' + snr.siteNumberRequestId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                                </div>
                            </td>
                            <td>{{snr.projectName}}</td>
                            <td>{{snr.workflowStatusDescription}}</td>
                        </tr>
                        <tr v-if="siteNumberRequest.length == 0">
                            <td colspan="3" style="background-color:#edf0f2; text-align:center">
                                No matching records
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </tab>
    </tabs>
    </div>
    </div>
    <div v-if="isDebug">
        <div>
            <h3 class="text-danger">****** Debug ******</h3>
        </div>
        <div>
        </div>
    </div>
    </div>
</template>

<script>

import loggingService from '../services/util/loggingService'
import culturalResourceService from '../services/culturalResourceService'
import culturalResourceRecordingService from '../services/culturalResourceRecordingService'
import culturalResourceIdentifierService from '../services/culturalResourceIdentifierService'
import locationService from '../services/siteForm/locationService'
import mediaService from '../services/mediaService'
import mapx from '@/views/MapNew'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import evaluationService from '@/services/siteForm/evaluationService'
import organizationService from '@/services/organizationService'
import lookupService from '@/services/lookup/lookupService'
import siteTypeService from '@/services/lookup/siteTypeService'
import siteNumberRequestService from '../services/siteNumberRequestService'
import gisService from '@/services/gisService'
import { mapState } from 'vuex'

import loader from '../components/Loader.vue'
import nationalRegisterStatus from '../components/SiteProduction/NationalRegisterStatus.vue'
import investigativeHistory from '../components/SiteProduction/InvestigativeHistory.vue'
import propertyDescription from '../components/SiteProduction/PropertyDescription.vue'
import siteSetting from '../components/SiteProduction/SiteSetting.vue'
import siteDocuments from '../components/SiteProduction/SiteDocuments.vue'
import attachments from '../components/SiteForm/Attachments.vue'
import culturalResourceRecordingHistory from '../components/CulturalResourceRecordingHistory.vue'
import labResults from '@/components/LabResults.vue'
import landOwnership from '../components/LandOwnership'

import identificationForm from '@/components/SiteForm/IdentificationForm.vue'
import locationForm from '@/components/SiteForm/LocationForm.vue'
import nationalRegisterStatusForm from '@/components/SiteForm/NationalRegisterStatusForm.vue'
import investigativeHistoryForm from '@/components/SiteForm/InvestigativeHistoryForm.vue'
import propertyDescriptionForm from '@/components/SiteForm/PropertyDescriptionForm.vue'
import siteSettingForm from '@/components/SiteForm/SiteSettingForm.vue'
import siteEligibilityForm from '@/components/SiteProduction/SiteEligibilityForm.vue'
import segmentEvaluationForm from '@/components/SiteProduction/segmentEvaluationForm.vue'
import modal from '@/components/Modal.vue'
import siteHeader from '../components/SiteHeader.vue'
import checkboxPanel from '@/components/CheckBoxPanel.vue'
import editor from '@tinymce/tinymce-vue'
import { tab, tabs } from 'vue-strap'

export default {
    components: {
        tabs,
        tab,
        nationalRegisterStatus,
        investigativeHistory,
        propertyDescription,
        siteSetting,
        culturalResourceRecordingHistory,
        loader,
        siteDocuments,
        attachments,
        labResults,
        mapx,
        identificationForm,
        locationForm,
        nationalRegisterStatusForm,
        investigativeHistoryForm,
        propertyDescriptionForm,
        siteSettingForm,
        siteEligibilityForm,
        segmentEvaluationForm,
        modal,
        siteHeader,
        landOwnership,
        checkboxPanel,
        editor
    },
    computed: {
        propertyTypeEnum: function () {
            return culturalResourceRecordingService.PropertyTypeEnum
        },
        isDistrictMember: function () {
            return (this.culturalResource.grouping === 'Group Member' && !(this.culturalResource.segment))
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isAdmin: function () {
            var allowedRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser
            ]
            return userService.hasRoleCheck(this.shpoUserDto.roleList, allowedRoleList)
        },
        isShpo: function () {
            var allowedRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            return userService.hasRoleCheck(this.shpoUserDto.roleList, allowedRoleList)
        },
        adminFormEnabled: function () {
            return this.isAdmin && this.formEnabledToggle
        },
        isMigrated: function () {
            return this.culturalResourceId <= 215676
        },
        eligibilityEnum: function () {
            return evaluationService.EligibilityEnum
        },
        isSegment: function () {
            return this.culturalResource && this.culturalResource.segment > 0
        },
        listedLandmarkMonument: function () {
            if (this.culturalResource) {
                var textList = []
                if (this.culturalResource.isListed) textList.push('Listed')
                if (this.culturalResource.isLandmark) textList.push('Landmark')
                if (this.culturalResource.isMonument) textList.push('Monument')
                return textList.join(', ')
            }
            return ''
        },
        currentEvalShpoConcurred: function () {
            return true
            //return this.currentEval.concurredId === evaluationService.ConcurredEnum.ShpoConcurred
        },
        elHistGridSpecColumns: function () {
            return this.isSegment ? ['view', 'dbi', 'reportTitle', 'recordingType', 'concurredDescription', 'effectDescription', 'completeDate', 'eligibilityDescription', 'contributingStatus']
                : ['view', 'dbi', 'reportTitle', 'recordingType', 'concurredDescription', 'effectDescription', 'completeDate', 'eligibilityDescription']
        }
    },
    data: function () {
        return {
            isDebug: false,
            activeTabIndex: 0,
            culturalResourceRecordingLoading: true,
            culturalResourceId: this.$route.params.culturalResourceId,
            crrId: null,
            culturalResource: {},
            culturalResourceRecording: {},
            culturalResourceIdentifiers: [],
            siteNumberRequest: [],
            location: {},
            currentEval: {},
            segmentHead: null,
            segHeadEval: null,
            mediaTypeId: mediaService.mediaType.CulturalResourceShapeFile.toString(),
            tabsEnum: {
                production: 0,
                productionLoaded: false,
                eligibility: 1,
                eligibilityLoaded: false,
                attachments: 2,
                attachmentsLoaded: false,
                siteDocuments: 3,
                siteDocumentsLoaded: false,
                map: 4,
                mapLoaded: false,
                history: 5,
                historyLoaded: false
            },
            formEnabledToggle: false,
            roleList: [],
            organizationList: [],
            confidentialOrgDto: {
                organizationId: null,
                description: ''
            },
            confidentialRoleList: [],
            confidentialOrgList: [],
            districtOwnershipTypeList: [],
            timePeriodList: [],
            siteTypeList: [],
            siteTrsList: [],
            editor: {
                options: {
                    selector: '#editor',
                    height: 500,
                    plugins: 'lists paste table',
                    oninit: 'setPlainText',
                    forced_root_block: false,
                    browser_spellcheck: true,
                    menubar: 'edit format',
                    toolbar: 'undo redo | fontselect fontsizeselect | bullist table',
                    table_default_attributes: {
                        border: '1',
                        width: '50%',
                        cellspacing: '0'
                    },
                    paste_postprocess: (plugin, args) => {
                        args.node.querySelectorAll('table').forEach(tableNode => {
                            tableNode.setAttribute('border', '1')
                            tableNode.setAttribute('cellspacing', '0')
                        })
                    },
                    content_style: 'body { font-family: Arial; }',
                    remove_linebreaks: false
                }
            },
            elHistGridSpec: {
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [5, 10, 25],
                    headings: {
                        view: 'View',
                        dbi: 'DBI',
                        reportTitle: 'Report Title',
                        recordingType: 'Recording Type',
                        concurredDescription: 'Source',
                        effectDescription: 'Effect',
                        completeDate: 'Completed Date',
                        eligibilityDescription: 'Eligibility',
                        contributingStatus: 'Contributing Status'
                    },
                    dateColumns: ['completeDate'],
                    orderBy: {
                        ascending: false,
                        column: 'completeDate'
                    }
                },
                tableData: []
            },
            eligibilityHistory: [],
            historicalTrs: []
        }
    },
    watch: {
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'Cultural Resource Recording', 'watch.activeTabIndex: ' + val)
            switch (val) {
            case this.tabsEnum.production: //production
                break
            case this.tabsEnum.eligibility: //eligibility
                if (!this.tabsEnum.eligibilityLoaded) this.loadEligibility()
                this.tabsEnum.eligibilityLoaded = true
                break
            case this.tabsEnum.attachments:
                if (!this.tabsEnum.attachmentsLoaded) this.$refs.attachments.loadData()
                this.tabsEnum.attachmentsLoaded = true
                break
            case this.tabsEnum.siteDocuments:
                if (!this.tabsEnum.siteDocumentsLoaded) this.$refs.siteDocuments.loadData()
                this.tabsEnum.siteDocumentsLoaded = true
                if (!this.tabsEnum.labResultsLoaded) this.$refs.labResults.loadData()
                this.tabsEnum.labResultsLoaded = true
                break
            case this.tabsEnum.map:
                if (!this.tabsEnum.mapLoaded) this.$refs.mapx.createMap()
                this.tabsEnum.mapLoaded = true
                break
            case this.tabsEnum.history:
                if (!this.tabsEnum.historyLoaded) this.$refs.crrHistory.loadData()
                this.tabsEnum.historyLoaded = true
                break
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Cultural Resource Production', 'mounted, ID: ' + this.$route.params.culturalResourceId)
        this.loadData()
    },
    methods: {
        loadData () {
            this.culturalResourceRecordingLoading = true
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loadData for CR Id' + this.culturalResourceId)
            culturalResourceRecordingService.getProduction(this.$http, this.culturalResourceId, true).then(response => {
                if (!response.data) {
                    this.$router.push('/CulturalResources')
                }
                this.culturalResourceRecording = response.data
                if (this.culturalResourceRecording.siteNarrative) {
                    this.culturalResourceRecording.siteNarrative = this.culturalResourceRecording.siteNarrative.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                if (this.culturalResourceRecording.buildingDescription) {
                    this.culturalResourceRecording.buildingDescription = this.culturalResourceRecording.buildingDescription.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                if (this.culturalResourceRecording.buildingHistory) {
                    this.culturalResourceRecording.buildingHistory = this.culturalResourceRecording.buildingHistory.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                // set crrId to attachments component
                //this.$refs.attachments.crrId = this.culturalResourceRecording.culturalResourceRecordingId
                this.crrId = this.culturalResourceRecording.culturalResourceRecordingId
                Promise.all([this.loadSiteNumberRequest(), this.loadCulturalResource(this.culturalResourceId), this.loadConfidentialSetting(this.culturalResourceId), this.loadIdentifier(),
                    this.loadLocation(), this.loadLookups(), this.loadHistoricEligibility(), this.loadHistoricalTrs()]).then(response2 => {
                        this.setSecondarySiteTypes()
                        this.setSecondaryTimePeriods()
                        this.culturalResourceRecordingLoading = false
                        // load all components once crr is set
                        if (!this.isSegment && !this.adminFormEnabled) {
                            Promise.all([this.$refs.nationalRegisterStatus.loadData(), this.$refs.investigativeHistory.loadData(),
                                this.$refs.propertyDescription.loadData(), this.$refs.siteSetting.loadData()])
                        } else {
                        }
                    })
            })
        },
        loadSiteNumberRequest () {
            var searchDto = {
                culturalResourceId: this.culturalResourceId
            }
            var handle = this
            siteNumberRequestService.searchCompleted(handle.$http, searchDto).then(function (response) {
                loggingService.log(handle.isDebug, 'Cultural Resource Production', 'loading SNR')

                handle.siteNumberRequest = response.data
            })
        },
        loadCulturalResource (culturalResourceId) {
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loading culturalResource: ' + culturalResourceId)
            return culturalResourceService.get(this.$http, culturalResourceId).then(response2 => {
                this.culturalResource = response2.data
                //this.culturalResource.propertyTypes = [this.culturalResource.siteTypeId]
                //this.culturalResource.timePeriods = [this.culturalResource.timePeriodId]

                //load CR TRS
                this.loadCulturalResourceTrs()

                //load Eligibility
                this.loadEligibility()
            })
        },
        loadCulturalResourceTrs () {
            if (!this.culturalResource.countyCode) return
            //use gisService to get site trs
            gisService.setGisServiceUrls(this.shpoUserDto.gisToken.token)
            var trsDto = {
                countyCode: this.culturalResource.countyCode,
                siteNumber: this.culturalResource.siteNumber,
                segment: this.culturalResource.segment
            }
            return gisService.siteToTrsQuery(trsDto).then(trsResult => {
                //set trs list and remove duplicates
                this.siteTrsList = trsResult.filter((item, index) => trsResult.indexOf(item) === index).sort()
            })
        },
        loadIdentifier () {
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loading cultural resource identifiers for ' + this.culturalResourceRecording.culturalResourceRecordingId)
            var searchDto = {culturalResourceRecordingId: this.culturalResourceRecording.culturalResourceRecordingId}
            return culturalResourceIdentifierService.search(this.$http, searchDto).then(response => {
                loggingService.log(this.isDebug, 'Cultural Resource Production', ' cultural resource identifier found: ' + response.data.length)
                this.culturalResourceIdentifiers = response.data
            })
        },
        loadLocation () {
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loading cultural resource location for ' + this.culturalResourceId)
            var searchDto = {culturalResourceRecordingId: this.culturalResourceRecording.culturalResourceRecordingId}
            return locationService.search(this.$http, searchDto).then(response => {
                if (response.data.length === 1) {
                    loggingService.log('found a location')
                    this.location = response.data[0]
                } else {
                    loggingService.log('no location found: ' + response.data.length)
                }
            })
        },
        loadConfidentialSetting (culturalResourceId) {
            loggingService.log(this.isDebug, 'CulturalResource Production', 'loading confidential settings')
            return culturalResourceService.getConfidentialSetting(this.$http, culturalResourceId).then(response => {
                this.confidentialRoleList = response.data.confidentialRoleList.map(role => { return role.roleId })
                this.confidentialOrgList = response.data.confidentialOrgList
            })
        },
        loadLookups () {
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loading role and organization lookups')
            organizationService.list(this.$http).then(result => {
                this.organizationList = result.data //.filter(x => { return (x.isBlmFieldOffice || x.isBlmDistrictOffice) })
            })
            roleService.list(this.$http).then(result => {
                var selectableList = [
                    roleService.RoleEnum.BlmUser,
                    roleService.RoleEnum.ConsultantUser,
                    roleService.RoleEnum.CLGConsultant,
                    roleService.RoleEnum.E106User
                ]
                this.roleList = result.data.filter(x => { return (selectableList.includes(x.description)) })
            })
            lookupService.listLookup(this.$http, 'DistrictOwnershipType').then(response => {
                this.districtOwnershipTypeList = response.data
            })
            lookupService.listLookup(this.$http, 'TimePeriod').then(response => {
                this.timePeriodList = response.data
            })
            siteTypeService.listLookup(this.$http, 'SiteType').then(response => {
                this.siteTypeList = response.data.map(x => {
                    return {
                        siteTypeId: x.id,
                        description: x.description
                    }
                })
            })
            return
        },
        loadEligibility () {
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loading current eligibility for ' + this.culturalResourceId)
            //check if site is segment, load normal eligibility if it's not, else load segmentEval component
            //if (!this.isSegment) {
            evaluationService.currentEligibility(this.$http, this.culturalResourceId).then(response => {
                this.currentEval = response.data
                if (this.currentEval) {
                    // var eligibility = evaluationService.EligibilityTypeList.find(x => { return x.eligibilityId === this.currentEval.eligibilityId })
                    // this.currentEval.eligibilityDescription = eligibility ? eligibility.description : ''
                    // var effect = evaluationService.EffectList.find(x => { return x.effectId === this.currentEval.effectId })
                    // this.currentEval.effectDescription = effect ? effect.description : ''
                    // var concurred = evaluationService.ConcurredList.find(x => { return x.concurredId === this.currentEval.concurredId })
                    // this.currentEval.concurredDescription = concurred ? concurred.description : ''
                } else {
                    //create new currentEval
                    this.currentEval = {
                        culturalResourceRecordingId: this.culturalResourceRecording.culturalResourceRecordingId,
                        isContributing: '',
                        eligibilityId: '',
                        effectId: '',
                        associatedCulturalResourceId: this.culturalResourceId,
                        evaluationSourceId: evaluationService.EvaluationSourceEnum.Current
                    }
                }
            })
            //}
            if (this.isSegment) {
                //load segment head and segment head eval
                culturalResourceService.getSegmentHead(this.$http, this.culturalResourceId).then(segHeadResult => {
                    if (segHeadResult.data) {
                        this.segmentHead = segHeadResult.data
                        //load the segment head current eval
                        evaluationService.currentEligibility(this.$http, this.segmentHead.culturalResourceId).then(segHeadEvalResult => {
                            if (segHeadEvalResult.data) {
                                this.segHeadEval = segHeadEvalResult.data
                            }
                            this.$refs.segmentEval.loadData()
                        })
                    } else {
                        this.$refs.segmentEval.loadData()
                    }
                })
            }
        },
        loadHistoricEligibility () {
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loading historic eligibility for ' + this.culturalResourceRecordingId)
            return evaluationService.historicEligibility(this.$http, this.culturalResourceId).then(response => {
                if (response.data) {
                    //console.log(response.data)
                    this.eligibilityHistory = response.data
                    //console.log(this.eligibilityHistory)
                }
            })
        },
        loadHistoricalTrs () {
            loggingService.log(this.isDebug, 'Cultural Resource Production', 'loading historical Trs for CR: ' + this.culturalResourceId)
            return culturalResourceService.listHistoricalCulturalResourceTrs(this.$http, this.culturalResourceId).then(response => {
                if (response.data) {
                    this.historicalTrs = response.data
                }
            })
        },
        toggleFormEnabled () {
            if (!this.formEnabledToggle) {
                if (confirm('You are about to enable site production data editing.  Are you sure you want to proceed?')) {
                    this.formEnabledToggle = !this.formEnabledToggle
                }
            } else {
                this.formEnabledToggle = !this.formEnabledToggle
                //reload the data
                this.loadData()
            }
        },
        setSecondarySiteTypes () {
            this.$refs.siteTypePanel.selectedList = this.culturalResourceRecording.secondarySiteTypeList.map(x => { return x.siteTypeId })
        },
        setSecondaryTimePeriods () {
            this.$refs.timePeriodPanel.selectedList = this.culturalResourceRecording.secondaryTimePeriodList.map(x => { return x.timePeriodId })
        },
        saveSiteNarrative () {
            culturalResourceRecordingService.put(this.$http, this.culturalResourceRecording)
        },
        clearConfidentialOrg () {
            this.confidentialOrgDto = {
                organizationId: null,
                description: ''
            }
        },
        addOrganization () {
            this.confidentialOrgDto.description = this.organizationList.find(x => { return x.organizationId === this.confidentialOrgDto.organizationId }).description
            this.confidentialOrgList.push(this.confidentialOrgDto)
            this.clearConfidentialOrg()
            this.$refs['organizationModal'].close()
        },
        removeOrganization (index) {
            this.confidentialOrgList.splice(index, 1)
        },
        goCulturalResourceGroup () {
            var crrId = this.culturalResourceRecording.culturalResourceRecordingId
            var resourceId = this.culturalResource.resourceId
            var crId = this.culturalResource.culturalResourceId
            this.$router.push({ name: 'CulturalResourceGroup', query: { resourceId: resourceId, culturalResourceRecordingId: crrId, culturalResourceId: crId, prod: true, isEdit: this.formEnabledToggle } })
        },
        saveConfidentialSetting () {
            var settingDto = {
                culturalResourceId: this.culturalResourceId,
                confidentialOrgList: this.confidentialOrgList.map(org => {
                    return {
                        culturalResourceId: this.culturalResourceId,
                        organizationId: org.organizationId
                    }
                }),
                confidentialRoleList: this.confidentialRoleList.map(role => {
                    return {
                        culturalResourceId: this.culturalResourceId,
                        roleId: role
                    }
                })
            }
            culturalResourceService.saveConfidentialSetting(this.$http, settingDto)
            if (this.$refs.identificationForm) this.$refs.identificationForm.saveOverview()
        }
    }
}

</script>

<style>
/* TODO: figure out where to override panel-heading in css file */
.green-bg {
    background: #5f817e !important;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 55px;
  z-index: 50;
  height: 50px;
  background-color: rgb(194, 194, 178);
  padding: 0 10px;
  color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.sticky ul {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-left: 0;
  height: inherit;
}

.sticky li {
  list-style: none;
  height: 100%;
  line-height: 50px;
}

.sticky li a {
  display: block;
  text-decoration: none;
  color: #263c46;
  height: 100%;
  width: 100%;
  padding: 0 5px;
}

.sticky li a:hover {
  background-color: rgb(194, 194, 178);
  filter: brightness(85%);
}

#overview {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// culturalResource.vue?032135b5